module.exports = __webpack_public_path__ + "img/check-white.93ab1bf0.png";